import {importEntitiesService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      importEntitiesService: undefined
    };
  },
  created: function() {
    this.importEntitiesService = importEntitiesService;
  }
};
